module.exports = __webpack_public_path__ + "img/en_3.52df69f3.jpg";